import { render, staticRenderFns } from "./BorrarModalComponent.vue?vue&type=template&id=17d6c6af"
import script from "./BorrarModalComponent.vue?vue&type=script&lang=js"
export * from "./BorrarModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports